
<style scoped lang="scss">
  @import '~@/assets/styles/vars';

  .scope {
    // @extend .t-pink;
    font-family: $ff_basic;
    display: inline-block;
    border-radius: 2px;
    width: 150px;
    // height: 24px;
    font-size: 1.5rem;
    padding: 1rem;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 2px;
  }

</style>

<template>
  <div :class="classObject" :style="styleObject" @click="onClick">
    {{label}}
  </div>
</template>

<script>
export default {
  name: 'activation-button',

  props: {
    label: String,
    classes: String,
    inactive: Boolean,
    width: Number,
  },

  computed: {
    styleObject() {
      return {
        width: this.width+"px",
      }
    },
    classObject() {
      return {
        // scope: true,
        't-pink scope': true,
        inactive: this.inactive,
      }
    },
  },

  methods: {
    onClick: function(e) {
      // console.log('pushed')
      // if (this.inactive) return;
      this.$emit('push', e);
    }
  },

  // data () {
  //   return {  }
  // },
}
</script>




// WEBPACK FOOTER //
// src/components/sub/ActivationButton.vue